// AlertDialog.js
import React from 'react';
import { useAlert } from './AlertContext';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

// import MUI dialog components
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

const AlertDialog = () => {
    const { alert, hideAlert } = useAlert();

    // convert the message to an array, splitting on newlines if needed
    const messageLines = (typeof alert?.message === "string") ?  [alert?.message] : alert?.message ?? [];
    const messageContent = messageLines.map((line, index) => {
        if (typeof line !== "string") return line;
        else {
            if (line.length === 0) line="&nbsp;";
            return <p key={index} dangerouslySetInnerHTML={{__html: line}}></p>;
        }
    });

    const actions = alert?.actions ?? [{
        title: 'OK',
        handler: hideAlert
    }];

    const messageBoxStyle = "px-7 py-6 min-h-48 max-h-72 overflow-auto" + ((alert?.border) ? " border-t border-b" : "");

    return (
        <Dialog open={!!alert} onClose={hideAlert} fullWidth maxWidth={alert?.size ?? "sm"}>
            <DialogTitle className="bg-gray-50">
                <span className="font-bold">{alert?.title ?? "Alert"}</span>
            </DialogTitle>
            <Box className={messageBoxStyle}>
                {messageContent}
            </Box>
            <DialogActions>
                {
                    actions.map((action, index) => {
                        return (
                            <Button key={index} variant={action.variant ?? 'text'} onClick={() => (typeof action.handler === "function") ? action.handler() : hideAlert()}>
                                {action?.title ?? "Action " + (index + 1)}
                            </Button>
                        );
                    })
                }
            </DialogActions>
        </Dialog>
    );
};

export default AlertDialog;
